"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Log = void 0;
const core_1 = require("flow-connect/core");
const utils_1 = require("flow-connect/utils");
class Log extends core_1.Node {
    constructor() {
        super();
    }
    setupIO() {
        this.addTerminals([
            { type: core_1.TerminalType.IN, name: "Log 1", dataType: "event" },
            { type: core_1.TerminalType.IN, name: "Log 2", dataType: "any" },
        ]);
    }
    created(options) {
        const { width = 170, name = "Log", style = {} } = options;
        this.width = width;
        this.name = name;
        this.style = Object.assign({ rowHeight: 10 }, style);
        this.setupUI();
        this.setupListeners();
    }
    process() { }
    addNewTerminal(type) {
        const newTerminal = this.addTerminal({
            type: core_1.TerminalType.IN,
            dataType: type === "event" ? type : "any",
            name: "Log " + (this.inputs.length + 1),
        });
        newTerminal.on(type, (terminal, data) => utils_1.Log.log(terminal.name, data));
    }
    setupUI() {
        this.addEventButton = this.createUI("core/button", { text: "Add Event", style: { grow: 0.5 } });
        this.addDataButton = this.createUI("core/button", { text: "Add Data", style: { grow: 0.5 } });
        this.ui.append(this.createUI("core/x-layout", {
            childs: [this.addEventButton, this.addDataButton],
            style: { spacing: 20 },
        }));
    }
    setupListeners() {
        this.inputs.forEach((term) => {
            if (term.dataType === "event") {
                term.on("event", (terminal, data) => utils_1.Log.log(terminal.name + ":", data));
            }
            else {
                term.on("data", (terminal, data) => utils_1.Log.log(terminal.name + ":", data));
            }
        });
        this.addEventButton.on("click", () => this.addNewTerminal("event"));
        this.addDataButton.on("click", () => this.addNewTerminal("data"));
    }
}
exports.Log = Log;
